import React, { useState } from 'react';

import {  ActionList, ActionMenu, IconButton } from '@primer/react';

import { KebabHorizontalIcon } from '@primer/octicons-react';

import COLORS from '../../../constants/colors.constants';

export const AssayDropDownOptions = ({ actionListOnSelect, actionListArray }) => {
  const [isOpen, setIsOpen] = useState(false)
  
  const iconButtonProps = {
    color: COLORS.brand, 
    borderRadius: '0.25rem'
  }

  return (
    <ActionMenu open={isOpen} onOpenChange={open => setIsOpen(open)}>
      <ActionMenu.Anchor>
        <IconButton icon={KebabHorizontalIcon} size="large" sx={iconButtonProps} variant="invisible" />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay sx={{ borderRadius: '0.5rem' }}>
        {
          actionListArray.map(({ id, label }) => (
            <ActionList.Item
              key={id}
              id={id}
              className="bg-white hover:bg-border-light"
              value={id}
              onClick={() => { 
                setIsOpen(false) 
                actionListOnSelect(id) 
              }}
              sx={{ width: '100%' }}
            >
              {label}
            </ActionList.Item>
          ))
        }
        
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
